import React from 'react';
import { evaluate } from '../../controllers/base/evaluate.js';

function isVirtualSurfaceModeOption(option) {
    return option.surfaceType === 'virtual';
}
function isFloatSurfaceModeOption(option) {
    return option.gridType === 'float';
}
function isHorizontalSurfaceModeOption(option) {
    return option.gridType === 'horizontal';
}
function isVerticalSurfaceModeOption(option) {
    return option.gridType === 'vertical';
}
function isStackSurfaceModeOption(option) {
    return option.gridType === 'stack';
}
/**
 * @public
 * 每个 Surface 内都可以通过 SurfaceContext 获取所属 Surface 的信息
 */
const SurfaceContext = React.createContext({
    evaluateWithContext: (config, defaultValue, ...args) => evaluate(config, defaultValue, ...args),
});

export { SurfaceContext, isFloatSurfaceModeOption, isHorizontalSurfaceModeOption, isStackSurfaceModeOption, isVerticalSurfaceModeOption, isVirtualSurfaceModeOption };
//# sourceMappingURL=surface-type.js.map
